import { createClient } from '@supabase/supabase-js'
import type { Database } from '../types/database'
import { env } from './env'

/**
 * The one Supabase client for the app, typed against the generated schema
 * (types/database.ts) so a renamed or retyped column fails the build rather
 * than a screen.
 *
 * `detectSessionInUrl` is what actually consumes an auth callback, and it does
 * so on WHATEVER route the callback lands on. That matters here because the two
 * sign-in paths land in different places:
 *
 *   - OAuth and magic link both now land DIRECTLY on the rep's original
 *     destination (`SITE_URL + next`) — see `otp-request`'s `next` param and
 *     `AuthProvider.signInWithProvider`. `/auth/callback` is a legacy
 *     fallback, not the primary path for either one anymore.
 *
 * So callback handling must not be bolted to one route. AuthProvider watches for
 * a session appearing on any route and reacts there.
 */
export const supabase = createClient<Database>(env.supabaseUrl, env.supabasePublishableKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
})
